<template>
  <div class="app">
    <div class="errors" v-if="errors.length > 0">
      <p v-for="(error, index) in errors" :key="'error' + index ">
        Error : {{ error }}
      </p> 
    </div>
    <template v-else>
      <search-engine 
        @found="foundHandler"
        @clear="clearHandler"
        @nothing="nothingHandler"
        @error="setError"
        :suggestions-url="suggestionsUrl"
        :placeholder="t('placeholder')"
      />
      <p v-if="hasFileFound">
        <a target='_blank' rel="noopener" :href="baseFileUrl + '/' + foundElement.file">{{ t('download', foundElement.file) }}</a>
      </p>
      <p v-if="hasReferenceFoundButWithoutFile">
        {{ t('not-here') }}
      </p>
      <p v-if="hasNoReferenceFound">
        {{ t('not-found') }}
      </p>
    </template>
  </div>
</template>

<script>
import searchEngine from "./components/searchEngine.vue";
const suggestionsUrl = "/static/files.json";
const langUrl = "/static/lang.json";

export default {
  name: "baco-search-engine",
  components: {
    searchEngine
  },
  props: {
    baseFileUrl: {
      type: String,
      default: ""
    },
    suggestionsUrl: {
      type: String,
      default: suggestionsUrl
    },
    lang: {
      type: String,
      default: "fr"
    },
    langUrl: {
      type: String,
      default: langUrl
    }
  },
  data() {
    return {
      errors: [],
      defaultLang: "fr",
      foundElement: null,
      langs: {}
    };
  },
  methods: {
    t(chaine, replacement) {
      if (!this.dictionnary[chaine]) {
        return chaine;
      }
      if (this.dictionnary[chaine] && replacement) {
        return this.dictionnary[chaine].replace("%s", replacement);
      }
      return this.dictionnary[chaine];
    },
    clearHandler() {
      this.foundElement = null;
    },
    nothingHandler() {
      this.foundElement = false;
    },
    foundHandler(datas) {
      this.foundElement = datas;
    },
    setError(message) {
      this.errors.push(message);
    }
  },
  computed: {
    hasFileFound() {
      return this.foundElement && this.foundElement.file;
    },
    hasReferenceFoundButWithoutFile() {
      return this.foundElement && this.foundElement.file === false;
    },
    hasNoReferenceFound() {
      return this.foundElement === false;
    },
    dictionnary() {
      return this.langs[this.lang] || this.langs[this.defaultLang] || {};
    }
  },
  mounted() {
    this.$axios
      .get(this.langUrl)
      .then(({ data }) => {
        this.langs = data;
      })
      .catch(error => {
        console.error(error);
        this.setError("Translations not found");
      });
  }
};
</script>

<style lang="scss">
#app {
  padding: 1px;
}
.errors {
  p {
    background-color: #bb0000;
    color: white;
    padding: 10px;
    font-size: 14px;
    width: 100%;
    box-sizing: border-box;
    font-family: Arial, Helvetica, sans-serif;
  }
}
</style>
